/**
 * Copyright (c) 2025 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Eugen Becker <e.becker@techdivision.com>
 */

import React from 'react';
import {ResultDisplay} from './ResultDisplay';
import {Tooltip} from './Tooltip';
import {useHeatCalculator} from '../JavaScript/UseHeatCalculator';

export const HeatCalculatorComp = ({ energyTypes }) => {
  const {
    errors,
    result,
    annualConsumption,
    annualConsumptionOnChange,
    selectEnergy,
    isSelected,
    handleSubmit,
  } = useHeatCalculator({
    energyTypes,
  });

  return (
    <>
      <hr />
      <form onSubmit={handleSubmit}>
        <div className="input-wrapper">
          <div className="energy-selector">
            <Tooltip text={'Energieart mit der Sie aktuell heizen.'}>
              <span className="label">Energieart wählen</span>
            </Tooltip>
            <div className="selectbox">
              {energyTypes.map((energyType) => (
                <button className={isSelected(energyType.name) ? 'selected' : ''}
                        key={energyType.name}
                        type={'button'}
                        onClick={() => selectEnergy(energyType.name)}>
                  {energyType.name} ({energyType.unit})
                </button>
              ))}
            </div>
            {errors.energy && (<span className="error">{errors.energy}</span>)}
          </div>
          <div className="annual-consumption-input">
            <Tooltip text={'Ihre jährliche Gesamtverbrauchsmenge der im vorherigen Schritt ausgwählten Energieart.'}>
              <label htmlFor={'annualConsumption'} className="label">Jährlicher Energiebedarf</label>
            </Tooltip>
            <input
              id="annualConsumption"
              type="number"
              className="form-control"
              min="0"
              placeholder="Verbrauchsmenge (ohne Einheit)"
              value={annualConsumption}
              onChange={annualConsumptionOnChange}
            />
            {errors.consumption && (<span className="error">{errors.consumption}</span>)}
          </div>
        </div>
        <div className="calculate-wrapper btn-wrapper">
          <button className="btn btn-cta" type="submit">
            <span className="btn-cta-text icon-arrow-right">Jetzt berechnen</span>
          </button>
        </div>
      </form>
      <hr />
      <ResultDisplay result={result} />
    </>
  );
};
